import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=a1427c1a&scoped=true"
import script from "./unbind.vue?vue&type=script&lang=js"
export * from "./unbind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1427c1a",
  null
  
)

export default component.exports